import Welcome from './welcome.vue'
import Accounts from './accounts.vue'
import AccountEditor from '../../components/account-editor/account-editor.vue'

/**
 * Administrative views of the Accounts applet, available to administrators only:
 * the welcome page with account statistics, the listing of all accounts and the editor of any account
 */
const administrator = {
  secure: true,
  permissions: ['administrator']
}

export default [
  {
    name: 'accounts-summary',
    path: 'summary',
    component: Welcome,
    meta: administrator
  },
  {
    name: 'accounts-list',
    path: 'all',
    component: Accounts,
    meta: administrator
  },
  {
    name: 'account-editor',
    path: 'account/:id(\\d+)',
    component: AccountEditor,
    meta: administrator
  }
]
